import { useEffect, useRef } from "react";

/**
 * Attaches an event listener to `document` and removes it on unmount.
 * The handler is stored in a ref — callers do not need to memoize it.
 */
export function useDocumentEventListener<K extends keyof DocumentEventMap>(
  type: K,
  handler: (event: DocumentEventMap[K]) => void
): void {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    function listener(event: DocumentEventMap[K]) {
      handlerRef.current(event);
    }
    document.addEventListener(type, listener);
    return () => document.removeEventListener(type, listener);
  }, [type]);
}
